/**
 * Created by FDD on 2017/5/15.
 * @desc 点要素
 */
import { Map } from 'ol';
import { Point } from 'ol/geom';
import { PlotTypes } from '@/utils/PlotTypes';
import type { Point as TPoint } from '@/utils/utils';

class Pennant extends Point {
  type: PlotTypes;

  fixPointCount: WithUndef<number>;

  map: any;

  points: TPoint[];

  freehand: boolean;

  options: any;

  constructor(coordinates, point, params) {
    super([]);
    this.type = PlotTypes.PENNANT;
    this.options = params || {};
    this.freehand = false;
    this.fixPointCount = undefined;
    this.set('params', this.options);
    if (point && point.length > 0) {
      this.setPoints(point);
    } else if (coordinates && coordinates.length > 0) {
      this.setCoordinates(coordinates);
    }
  }

  /**
   * 获取标绘类型
   * @returns {*}
   */
  getPlotType() {
    return this.type;
  }

  generate() {
    this.setCoordinates(this.points);
  }

  /**
   * 设置地图对象
   * @param map
   */
  setMap(map) {
    if (map && map instanceof Map) {
      this.map = map;
    } else {
      throw new Error('传入的不是地图对象！');
    }
  }

  /**
   * 获取当前地图对象
   * @returns {{}|*}
   */
  getMap() {
    return this.map;
  }

  /**
   * 判断是否是Plot
   * @returns {boolean}
   */
  isPlot() {
    return true;
  }

  /**
   * 设置坐标点
   * @param value
   */
  setPoints(value) {
    this.points = !value ? [] : value;
    if (this.points.length >= 1) {
      this.generate();
    }
  }

  /**
   * 获取坐标点
   * @returns {Array.<T>}
   */
  getPoints() {
    return this.points.slice(0);
  }

  /**
   * 获取点数量
   * @returns {Number}
   */
  getPointCount() {
    return this.points.length;
  }

  /**
   * 更新当前坐标
   * @param point
   * @param index
   */
  updatePoint(point, index) {
    if (index >= 0 && index < this.points.length) {
      this.points[index] = point;
      this.generate();
    }
  }

  /**
   * 更新最后一个坐标
   * @param point
   */
  updateLastPoint(point) {
    this.updatePoint(point, this.points.length - 1);
  }

  /**
   * 结束绘制
   */
  finishDrawing() {}
}

export default Pennant;
